import GAMonitor from './GAMonitor'

export default GAMonitor
